<div mdbModal #thankYouModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true" [config]="{ignoreBackdropClick: true}">
  <div class="modal-dialog" role="document">
    <form (ngSubmit)="goToJobsPage()" novalidate>
      <div class="modal-content">
        <div class="modal-header">
        </div>
        <div class="modal-body">
          <app-thank-you></app-thank-you>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" mdbWavesEffect>Browse More Jobs</button>
        </div>
      </div>
    </form>
  </div>
</div>
